import { render } from "./MonthlyPlans.vue?vue&type=template&id=1498dfea&scoped=true"
import script from "./MonthlyPlans.vue?vue&type=script&lang=js"
export * from "./MonthlyPlans.vue?vue&type=script&lang=js"

import "./MonthlyPlans.vue?vue&type=style&index=0&id=1498dfea&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1498dfea"]])

export default __exports__